import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./features/features-routing.module').then((module) => module.routes)
	},
	{
		path: '**',
		redirectTo: ''
	}
];
